<template>
    <transition name="fade">
       <div v-if="!isAuthenticated" class="modal">
            <img class="cover" src="https://blog.studio14a.com/static/images/qb3/phones.png"/>
            <h2>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                    <path d="M16 12H17.4C17.7314 12 18 12.2686 18 12.6V19.4C18 19.7314 17.7314 20 17.4 20H6.6C6.26863 20 6 19.7314 6 19.4V12.6C6 12.2686 6.26863 12 6.6 12H8M16 12V8C16 6.66667 15.2 4 12 4C8.8 4 8 6.66667 8 8V12M16 12H8" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Login
            </h2>
            <div>
                <input v-model="password" type="password" placeholder="Password" @keyup.enter="login" @keydown="errored = false"/>
                <button @click="login">
                    enter
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M13.25 19.25L16.75 15.75L13.25 12.25" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M16.75 15.75H10.75C8.54086 15.75 6.75 13.9591 6.75 11.75V4.75" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                </button>
            </div>
            <span class="error"> {{ errored ? 'Incorrect Password' : '‎' }} </span>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'login',
    props: {
        isAuthenticated: Boolean,
        setAuth: Function
    },

    computed: { },

    data: function(){
        return {
            errored: false,

            password: '',
        }
    },

    methods: {
        async login() {
            const response = await window.afetch('/login', {
                method: 'POST',
                body: JSON.stringify({ password: this.password }),
            });

            const data = await response.json();
            if(data.success === false) {
                this.errored = true
                return
            }

            window.localStorage.setItem('authToken', data.token)

            this.checkAuth();

            window.location.reload()
        },

        checkAuth() {
            this.setAuth(!!window.localStorage.getItem('authToken'))
        },

    },

    mounted: function(){
        this.checkAuth()
    }
}
</script>

<style scoped lang="scss">

.cover{
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
    top: 0;
    left: 0;
    opacity: 0.25;
}

.modal{
    position: relative;
    width: 50%;
    border-radius: 5px;
    color: black;
    padding: 100px 20px;
    left: 50%;
    margin-top: calc(50vh - 200px);
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    overflow: hidden;
}

div{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

input{
    border: 1px solid black;
    padding: 5px 5px;
    width: 100%;
    height: 25px;
    border-radius: 5px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

h2{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 20px;
    svg{
        width: 20px;
    }
}
button{
    color: white;
    background-color: black;
    height: 37px;
    padding: 0 10px;
    border-radius: 5px;
    outline: none;
    border: none;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    display:flex;
    flex-direction: row;
    align-items: center;

    svg{
        width: 20px;
        padding-left: 5px;
    }

}
span{
    font-size: 9px;
    color: red;
    padding-top: 20px;
}

</style>
